import { useNavigate } from "react-router-dom";
import { WorkOrderList } from "./WorkOrderList";

// 製單(規格 §8):左側「業務」區的「製單」。廠商分頁業主 2026-10-15 拿掉了(用不到)。

export function WorkOrdersPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-w-0 flex-col gap-3">
      <h2 className="m-0 text-xl font-semibold text-[var(--text)]">製單</h2>
      <WorkOrderList onOpen={(id) => navigate(`/workorders/${id}`)} onCreate={() => navigate("/workorders/new")} />
    </div>
  );
}
